<template>
    <transition name="fade">
        <div class="modal fade" id="modalGuide" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title bold" v-if="guide">{{guide.title}}</h5>
                    </div>
                    <div class="modal-body" v-if="guide">
                        <ul>
                            <li v-for="i in guide.contents">{{i.label}}</li>
                        </ul>
                        <div class="form-group" v-if="guide.code=='ATT103'">
                            <a href="/templatedFILE/Sample BIR Form 1701.pdf" download>Download Sample BIR Form 1701</a>
                            <br>
                            <a href="/templatedFILE/Sample BIR Form 1702.pdf" download>Download Sample BIR Form 1702</a>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        props: ['guidelines'],
        data() {
            return {
                guide: [...this.guidelines],
            }
        },

        created() {

        },
        methods: {
            getGuide(e)
            {
                this.guide = this.guidelines.find(i => i.code === e);
            }
        },
        computed: {},
        mounted() {}
    }
</script>



<style scoped>

</style>